// UserContext.js
import { createContext, useContext, useEffect, useState } from 'react';
import Supabase from './../backend/client';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);  
  const [userDetails, setUserDetails] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const getUserDetails = async (id) => {
    if (!id) return;
    let { data: profiles, error } = await Supabase
      .from('profiles')
      .select('*')
      .eq("id", id);
    
    if (profiles?.length) {
      setUserDetails(profiles[0]);
      setIsAdmin(profiles[0]?.role === 'admin');
    }
  }

  const updateUserDetails = async () => {
    if (!userDetails?.id) return;
    const {data, error} = await Supabase.from('profiles').select().eq('id', userDetails.id);
    if (data?.length) {
      setUserDetails(data[0]);
    }
  }

  useEffect(() => {
    const storedId = localStorage.getItem('userId');
    if (storedId) {
      getUserDetails(storedId);
    }

    const unsubscribe = Supabase.auth.onAuthStateChange((event, session) => {
      setUser(session?.user ?? null);
      if (session?.user) {
        getUserDetails(session.user.id);
        localStorage.setItem('userId', session.user.id);
      } else {
        localStorage.removeItem('userId');
      }
      setIsLoading(false);
    });

    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <UserContext.Provider value={{ user, userDetails, isAdmin, updateUserDetails, isLoading }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
};

export default UserContext;
